import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { Form, Select } from 'antd';
import { useIntl } from 'react-intl';
import {
	fetchOrganizations,
	clearOrganizations,
} from '@common/resources/Organization/actions';
import isEmpty from 'lodash.isempty';

const FormItem = Form.Item;
const { Option } = Select;

const OrganizationSelectForm = (props) => {
	const {
		organizations,
		organization,
		fetchOrganizations,
		clearOrganizations,
		formOrganizationProps,
	} = props;
	const intl = useIntl();
	useEffect(() => {
		const fetchData = async () => {
			await clearOrganizations();
			await fetchOrganizations();
		};
		fetchData();
	}, [organization]);

	const renderOrganizationOptions = useCallback(() => {
		if (!isEmpty(organizations)) {
			return organizations.map((organization, index) => {
				return (
					<Option
						value={organization._id}
						key={`organization-${index}`}
						title={organization?.title}>
						{organization?.title}
					</Option>
				);
			});
		}
	}, [organizations]);

	return (
		<FormItem
			name={'organization'}
			rules={[
				{
					required: true,
					message: intl.formatMessage({
						id: 'form.validation.transaction Category.required',
						defaultMessage: 'Please input transaction Category',
					}),
				},
			]}
			{...formOrganizationProps}>
			<Select
				style={{ width: '100%' }}
				placeholder="Please select transaction Category"
				optionFilterProp="title"
				filterOption={(input, option) =>
					option.props.children
						.toLowerCase()
						.indexOf(input.toLowerCase()) >= 0
				}>
				{renderOrganizationOptions()}
			</Select>
		</FormItem>
	);
};

const mapStateToProps = ({ organization, organizations }) => {
	return {
		organization,
		organizations,
	};
};

export default connect(mapStateToProps, {
	fetchOrganizations,
	clearOrganizations,
})(OrganizationSelectForm);
